<template>
  <div class="error">
    <el-empty :description="error.message">
      <template #image>
        <img src="../../../public/img/server_error.svg" ondragstart="return false">
      </template>
      <el-button @click="handleGoBack">{{ $t('common.back') }}</el-button>
    </el-empty>
  </div>
</template>

<script lang="ts" setup>
import { ElEmpty, ElButton } from 'element-plus';
import { useRouter } from 'vue-router';

const { error } = defineProps<{ error: Error }>()

const router = useRouter()
const handleGoBack = () => {
  setTimeout(() => window.location.reload(), 100)
  router.go(-1)
}
</script>